import {IStructureItem, StructureName} from "../client-site";

export const ALLOW_TO_SCHEDULE_DEFAULT = 14;
export const APPOINTMENT_STEP_GAP = 15;
// Default padding kept before and after every appointment (in minutes). 0 = back-to-back.
export const APPOINTMENT_BUFFER_MINUTES = 0;
// Options offered to the business owner for the gap between appointments.
export const APPOINTMENT_BUFFER_OPTIONS = [0, 5, 10, 15, 20, 30] as const;
export const ALLOW_TO_ENTER_WAITING_LIST_MIN = 1;
// Default window a customer may ask the waiting list to watch, in days ahead. A business can
// override it per-business via configurations.waitingListMaxDays (capped by the limit below).
export const ALLOW_TO_ENTER_WAITING_LIST_MAX = 10;
export const WAITING_LIST_MAX_DAYS_LIMIT = 120;

/** Effective waiting-list window for a business (days ahead), falling back to the default. */
export const resolveWaitingListMaxDays = (maxDays?: number): number => {
  if (!maxDays || maxDays < ALLOW_TO_ENTER_WAITING_LIST_MIN) return ALLOW_TO_ENTER_WAITING_LIST_MAX;
  return Math.min(maxDays, WAITING_LIST_MAX_DAYS_LIMIT);
};

export const BASIC_TEMPLATE_LEAD_COLOR_DEFAULT = "#F9DBDB";
export const BASIC_TEMPLATE_CTA_COLOR_DEFAULT = "#D91414";
export const DEFAULT_TEMPLATE = 'professional';
export const CUSTOMER_MARKER_COLOR_DEFAULT = 'white';
export const CUSTOMER_MARKER_COLORS: Array<{ key: string; value: string }> = [
  { key: 'white', value: '#FFFFFF' },
  { key: 'red', value: '#EF4444' },
  { key: 'orange', value: '#F97316' },
  { key: 'yellow', value: '#EAB308' },
  { key: 'green', value: '#22C55E' },
  { key: 'teal', value: '#14B8A6' },
  { key: 'blue', value: '#3B82F6' },
  { key: 'purple', value: '#A855F7' },
  { key: 'pink', value: '#EC4899' },
];

export const DEFAULT_STRUCTURE: Array<IStructureItem> = [
  {name: StructureName.DESCRIPTION, visible: true },
  {name: StructureName.SERVICES, visible: true },
  {name: StructureName.SOCIALS, visible: true },
  {name: StructureName.WORKING_HOURS, visible: true },
  {name: StructureName.LOCATION, visible: true },
  // {name: StructureName.GALLERY, visible: false },
]
